// components/RouteLoader.jsx
export default function RouteLoader() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <img
        src="/loader.gif"
        alt="Loading"
        width={100}
        className="animate-spin"
      />
    </div>
  );
}
